import moment from 'moment'
import { DATE_FORMAT } from '../constants'
import { useAddresses, useJobStatusText } from '../hooks'
import { Job } from '../interfaces'
import { Col, Flex, Row } from './flex'
import { PrimaryText, Text } from './text'

interface JobInfoProps {
    job?: Job
    trackingId: string
}

export const JobInfo = ({ job, trackingId }: JobInfoProps) => {
    const date = job?.bookingDate
        ? moment(job?.bookingDate).format(DATE_FORMAT)
        : ''
    const { delivery } = useAddresses(job?.stops)
    const latestEvent = job?.jobAudit?.[0].description ?? ''
    const jobStatus = useJobStatusText(job?.status, job?.stops)
    const statusText = job?.showLatestEventAsStatus ? latestEvent : jobStatus
    const { company, address1, postcode, town } = delivery ?? {}
    const destination = [company, address1, postcode, town]
        .filter((item) => item)
        .join(', ')
    const itemReference = job?.items
        ? job?.items.map((item) => item.reference).join(', ')
        : ''

    return (
        <Flex className="border border-solid border-gray-400 p-4 flex-col sm:flex-row">
            <Col className="sm:pr-10 pb-4 sm:pb-0">
                <span className="text-primary-700 text-2xl">{trackingId}</span>
                {!job?.isStatusHidden && (
                    <Col className="border-l-4 border-solid border-primary-500 pl-2">
                        <span className="text-gray-700 text-xs">Status</span>
                        <span className="font-ubuntu-medium text-primary-500 text-sm leading-none uppercase">
                            {statusText}
                        </span>
                    </Col>
                )}
            </Col>
            <Col>
                <Row>
                    <PrimaryText className="min-w-32">
                        Item reference:
                    </PrimaryText>
                    <Text>{itemReference}</Text>
                </Row>
                <Row>
                    <PrimaryText className="min-w-32">Job date:</PrimaryText>
                    <Text>{date}</Text>
                </Row>
                <Row>
                    <PrimaryText className="min-w-32">Destination:</PrimaryText>
                    <Text>{destination}</Text>
                </Row>
            </Col>
        </Flex>
    )
}
